import { Badge } from "../../primitives/badge";
import { cn } from "../../primitives/utils";

interface SeverityBadgeProps {
  severity: "low" | "medium" | "high" | "critical";
  className?: string;
}

const severityConfig = {
  low: {
    label: "Low",
    className: "border-transparent",
    style: {
      backgroundColor: "var(--severity-low)",
      color: "var(--severity-low-foreground)",
    },
  },
  medium: {
    label: "Medium",
    className: "border-transparent",
    style: {
      backgroundColor: "var(--severity-medium)",
      color: "var(--severity-medium-foreground)",
    },
  },
  high: {
    label: "High",
    className: "border-transparent",
    style: {
      backgroundColor: "var(--severity-high)",
      color: "var(--severity-high-foreground)",
    },
  },
  critical: {
    label: "Critical",
    className: "border-transparent",
    style: {
      backgroundColor: "var(--severity-critical)",
      color: "var(--severity-critical-foreground)",
    },
  },
};

export function SeverityBadge({ severity, className }: SeverityBadgeProps) {
  const config = severityConfig[severity];

  return (
    <Badge className={cn(config.className, className)} style={config.style}>
      {config.label}
    </Badge>
  );
}
